export const FAILED_REQUESTS = 'failedRequests';
